import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogTitle, MatDialogActions, MatDialogClose } from '@angular/material/dialog';
import { MatButton } from '@angular/material/button';
import { TranslocoPipe } from '@jsverse/transloco';

@Component({
  selector: 'sibat-notice',
  template: `
    <h3 mat-dialog-title style="color:#e42313 ">{{ 'notification.motd' | transloco }}</h3>
    <div class="mat-typography">
      <p>{{ message }}</p>
    </div>
    <mat-dialog-actions align="end">
      <button mat-button mat-dialog-close style="background-color: #e42313; color: white">{{ 'layout.closeDialog' | transloco }}</button>
    </mat-dialog-actions>
  `,
  styleUrls: ['motd.component.scss'],
  imports: [MatDialogTitle, MatDialogActions, MatButton, MatDialogClose, TranslocoPipe],
})
export class MotdComponent {
  constructor(@Inject(MAT_DIALOG_DATA) public message: string) {}
}
